import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useClickOut } from '@websolutespa/bom-mixer-hooks';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import style from './page-intro.module.scss.js';

const PageIntro = () => {
  const ref = useRef(null);
  const {
    PageContext,
    PageDictate,
    PageMenu,
    PageStop,
    PageStreamingIndicator,
    PageSubmit,
    PageSynthesis,
    PageTextarea,
    PageUpload
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const streaming = useLlm(state => state.streaming);
  const opened = useLlmView(state => state.opened);
  const {
    open
  } = useLlmView(state => state.actions);
  useClickOut(ref, event => {
    var _a;
    const className = ((_a = event.target) === null || _a === void 0 ? void 0 : _a.getAttribute('class')) || '';
    // console.log('useClickOut', className);
    if (className.indexOf('llm') === -1 && opened) {
      open();
    }
  });
  if (!app) {
    return;
  }
  const contents = app.contents;
  const extendedWelcomeText = contents.extendedWelcomeText;
  return jsx("section", {
    className: style.intro,
    children: jsx("div", {
      className: style.container,
      children: jsxs("div", {
        className: style.content,
        children: [jsx("div", {
          className: style.head,
          children: extendedWelcomeText && jsx("h1", {
            className: style.title,
            dangerouslySetInnerHTML: {
              __html: extendedWelcomeText
            }
          })
        }), jsx("section", {
          ref: ref,
          className: style.prompt,
          "aria-label": "Prompt",
          children: jsxs("div", {
            className: style.inner,
            children: [jsxs("form", {
              className: getClassNames(style.form, '-form'),
              onSubmit: event => event.preventDefault(),
              children: [jsxs("div", {
                className: getClassNames(style.control, {
                  [style.streaming]: streaming
                }),
                children: [jsx(PageStreamingIndicator, {}), jsx(PageTextarea, {})]
              }), streaming ? jsx(PageStop, {}) : jsx(PageSubmit, {})]
            }), jsxs("div", {
              className: style.actions,
              children: [jsx("div", {
                className: style.left,
                children: jsx(PageMenu, {})
              }), jsxs("div", {
                className: style.right,
                children: [jsx(PageUpload, {}), jsx(PageContext, {}), jsx(PageDictate, {}), jsx(PageSynthesis, {})]
              })]
            })]
          })
        })]
      })
    })
  });
};

export { PageIntro };
//# sourceMappingURL=page-intro.js.map
